<template>
  <section class="container section pt-5" v-show="show">
    <div v-if="!is_order_placed">
      <div class="button mb-3 is-primary is-rounded" @click="$emit('home')">
        <span class="icon">
          <i class="fa fa-arrow-left"></i>
        </span>
        <span>{{ $t("back") }}</span>
      </div>
      <div class="title is-4">{{ $t("contact information") }}</div>
      <form>
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("name") }}</label>
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="meta.name"
                  :placeholder="$t('your name')"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("email") }}</label>
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="meta.email"
                  placeholder="mi-email@correo.com"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("email confirmation") }}</label>
              <div class="control">
                <input
                  type="text"
                  class="input"
                  v-model="meta.email_confirmation"
                  placeholder="mi-email@correo.com"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column is-two-fifths">
            <div class="field">
              <label class="label">{{ $t("phone") }}</label>
              <div class="control">
                <input
                  type="number"
                  class="input"
                  v-model="meta.phone"
                  placeholder="5543 2211"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("address") }}</label>
              <div class="control">
                <textarea
                  rows="2"
                  class="textarea"
                  v-model="meta.address"
                  :placeholder="$t('your address')"
                ></textarea>
              </div>
            </div>
          </div>
        </div>

        <div class="title is-4">{{ $t("select your products") }}</div>
        <div class="grid is-col-min-12">
          <div class="cell" v-for="(product, pidx) in product_catalog">
            <div class="card">
              <div class="card-image">
                <figure class="image is-4by3">
                  <v-lazy-image
                    v-if="
                      product.settings.images && product.settings.images.length
                    "
                    :src="`${api_host}/drive/static/${product.settings.images[0].final_name}`"
                  />
                  <img
                    v-else
                    src="https://bulma.io/assets/images/placeholders/1280x960.png"
                  />
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-content">
                    <div class="is-pulled-right">
                      <div class="button" @click="remove_product(product)">
                        <span class="icon">
                          <i class="fa fa-minus"></i>
                        </span>
                      </div>
                      <div class="button is-primary" v-if="product.quantity">
                        {{ product.quantity }}
                      </div>
                      <div class="button" @click="add_product(product)">
                        <span class="icon">
                          <i class="fa fa-plus"></i>
                        </span>
                      </div>
                    </div>
                    <p
                      class="title is-4"
                      v-bind:class="{ 'has-text-primary': product.quantity }"
                    >
                      {{ product.name }}
                    </p>
                    <p class="subtitle is-6">
                      {{ format_currency(product.sale_price) }}
                    </p>
                  </div>
                </div>
                <div class="field" v-if="product.quantity">
                  <label class="label">{{ $t("customization") }}</label>
                  <div class="control">
                    <textarea
                      class="textarea"
                      rows="2"
                      v-model="product.customization"
                    ></textarea>
                  </div>
                </div>

                <div class="content">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Phasellus nec iaculis mauris.
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div class="content" v-if="order_summary && order_summary.length">
        <div class="title is-4">{{ $t("order summary") }}</div>
        <ul>
          <li v-for="(itm, iidx) in order_summary" :key="iidx">
            {{ itm.quantity }} x {{ itm.name }} =
            {{ format_currency(itm.total) }}
          </li>
        </ul>
      </div>

      <article class="message is-info mt-3">
        <div class="message-body">
          {{
            $t(
              "to place your order, verify you fill all fields and every product has quantity"
            )
          }}
        </div>
      </article>
      <div class="field">
        <div class="control">
          <button
            :disabled="is_invalid"
            class="button is-rounded is-primary"
            v-bind:class="{ 'is-loading': loading }"
            @click="create"
          >
            <span class="icon">
              <i class="fa fa-save"></i>
            </span>
            <span>{{ $t("make order") }}</span>
          </button>
          <div class="tag is-large is-primary is-pulled-right">
            {{ $t("total") }} {{ format_currency(total) }}
          </div>
        </div>
      </div>
    </div>
    <!-- <pre>{{ meta }}{{ order_link }}</pre> -->
    <article class="message is-info" v-if="is_order_placed">
      <div class="message-header">
        <p>{{ $t("order placed") }}!</p>
      </div>
      <div class="message-body">
        <figure class="image is-4by3">
          <v-lazy-image
            src="https://i.pinimg.com/736x/7e/0a/1a/7e0a1a256a5ec1868255c6527430aeea.jpg"
          />
        </figure>
      </div>
    </article>
  </section>
</template>

<script>
import {
  get,
  post,
  error_message,
  success_message,
  format_currency,
  api_host,
} from "@/utils";
import VLazyImage from "v-lazy-image";

export default {
  name: "BakeryOrderOrder",
  components: { VLazyImage },
  computed: {
    total() {
      let v = this;
      let total = v.product_catalog
        .filter((p) => p.quantity)
        .reduce((prev, curr) => {
          return prev + curr.quantity * Number(curr.sale_price);
        }, 0);
      return total;
    },
    is_invalid() {
      let v = this;
      // return false;
      return (
        !v.meta.name ||
        !v.meta.email ||
        !v.meta.phone ||
        !v.meta.address ||
        // v.meta.selected_products.length == 0 ||
        !v.product_catalog.find((sp) => sp.quantity) ||
        !v.meta.email_confirmation ||
        v.meta.email != v.meta.email_confirmation
      );
    },
    order_summary() {
      let v = this;
      let summary = v.product_catalog
        .filter((p) => p.quantity)
        .map((p) => {
          return {
            name: p.name,
            quantity: p.quantity,
            total: p.quantity * Number(p.sale_price),
          };
        });
      return summary;
    },
  },
  data() {
    return {
      is_order_placed: false,
      api_host,
      order_link: {},
      loading: false,
      meta: {
        name: "",
        email: "",
        phone: "",
        address: "",
        selected_products: [],
      },
      product_catalog: [],
      show: false,
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      // let products = v.meta.selected_products.map((sp) => {
      //   delete sp.product.available_sizes;
      //   return sp;
      // });
      // v.meta.selected_products = products;
      v.$root.loader(true);
      v.loading = true;
      let data = {
        ...v.meta,
        products: v.product_catalog.filter((p) => p.quantity),
      };
      post("/bakery_order/online", data)
        .then((r) => {
          v.$root.loader(false);
          v.loading = false;
          v.is_order_placed = true;
          setTimeout(() => {
            location.reload();
          }, 5000);
          console.log(r);
        })
        .catch((error) => {
          v.$root.loader(false);
          v.loading = false;
          error_message(error);
          console.error(error);
        });
    },
    add_product(product) {
      let v = this;
      if (product.quantity) product.quantity++;
      else product.quantity = 1;
    },
    remove_product(product) {
      let v = this;
      if (product.quantity) product.quantity--;
      else product.quantity = 0;
    },
    show_component() {
      let v = this;
      v.show = true;
    },
    hide() {
      let v = this;
      v.show = false;
    },
    set_order_link(order_link) {
      let v = this;
      v.order_link = order_link;
    },
  },
  mounted() {},
  created() {
    let v = this;
    // Get product catalog
    get("/bakery_order/online/products", {})
      .then((r) => {
        v.product_catalog = r;
      })
      .catch((error) => {
        error_message(error);
        console.error(error);
      });
  },
};
</script>

<style scoped></style>
